import { keysToCamel } from "@lib/snakeTocamel"

export const parseBottomSheet = (sheetData) => {
    let bottomSheetData = {}
    Object.keys(sheetData)?.map((sheetName) => {
        switch (sheetName) {
            case "needHelp":
                bottomSheetData[sheetName] = {
                    header: sheetData[sheetName]?.data?.header,
                    data: {
                        linksData: sheetData[sheetName]?.data?.items?.map((item) => ({
                            header: item?.name,
                            subTitle: item?.sub_text,
                            image: item?.icon,
                            type: item?.type,
                            url:
                                item?.type === "call"
                                    ? `tel:${item.cta?.details?.support_contact}`
                                    : item?.cta?.details?.target_url,
                            isExternal: true,
                            cta: keysToCamel(item?.cta),
                        })),
                        gaDetails: sheetData[sheetName]?.ga_details,
                    },
                }
                return
            default:
                bottomSheetData[sheetName] = keysToCamel(sheetData?.[sheetName])
                return
        }
    })
    return bottomSheetData
}

export const parseResponseData = (data) => {
    const widgetData = data?.widgets
    if (!widgetData || widgetData.length === 0) return []
    const flags = {}

    const parsedData = Object.keys(widgetData)?.map((item) => {
        const widget = widgetData[item]
        const widgetType = widget?.key
        switch (widgetType) {
            case "separator": {
                return {
                    key: widgetType,
                    size: widget.size,
                }
            }
            case "booking_header":
                return {
                    key: widgetType,
                    header: widget.header,
                    description: widget.description,
                    tag: keysToCamel(widget?.tag),
                }
            case "test_details":
            case "customer_detail": {
                return {
                    key: widgetType.toLowerCase(),
                    stepInfo: keysToCamel(widget.step_info),
                    type: widget.type,
                    overviewInfo: keysToCamel(widget.overview_info),
                    data: keysToCamel(widget.data),
                }
            }
            case "test_location": {
                const data = keysToCamel(widget.data)
                if (!data.cta.isShow) {
                    flags.isEditAddressDisabled = true
                }
                flags.isRehash = data.addressDetails.rehash
                const overviewInfo = keysToCamel(widget.overview_info)
                overviewInfo.description = [
                    data?.addressDetails.street || "",
                    data?.addressDetails.city || "",
                    data?.addressDetails.state || "",
                    data?.addressDetails.pincode || "",
                ].join(" ")
                overviewInfo.hideDescriptionOnExpand = true
                return {
                    key: widgetType.toLowerCase(),
                    stepInfo: keysToCamel(widget.step_info),
                    type: widget.type,
                    overviewInfo,
                    data,
                }
            }
            case "test_slot": {
                const overviewInfo = keysToCamel(widget.overview_info)

                flags.isSlotDisabled = overviewInfo.link.isDisabled

                return {
                    key: widgetType.toLowerCase(),
                    stepInfo: keysToCamel(widget.step_info),
                    type: widget.type,
                    overviewInfo,
                    data: keysToCamel(widget.data),
                }
            }
            case "help_info": {
                return {
                    ...keysToCamel(widget),
                }
            }
            case "booking_cta": {
                return {
                    key: widgetType,
                    isDisabled: widget.is_disabled,
                    size: widget.size,
                    type: widget.type,
                    label: widget.label,
                    action: widget.action,
                    gaDetails: widget.ga_details,
                }
            }
        }
    })
    const popups = data?.popups
    const bookingFailedPopup = popups?.booking_failed
    bookingFailedPopup.image = { ...bookingFailedPopup.image, height: "96px", width: "96px" }
    return {
        widgets: parsedData,
        gaDetails: data?.ga_details,
        loaderArray: data?.loader_array,
        bottomSheets: parseBottomSheet(data?.bottom_sheets),
        isReschedule: data?.is_rescheduled,
        popups,
        metaData: keysToCamel(data?.meta_data),
        flags,
    }
}

export const parseLeadAddress = (data, isRehash) => {
    const addressData = data?.widgets[0]?.data
    const addressDetails = {
        recipientName: addressData?.name,
        recipientPhone: addressData?.number,
        city: addressData?.city,
        pincode: addressData?.pincode,
        state: addressData?.state,
        addressText: addressData?.street1,
        showRecipientName: true,
        name: addressData?.addressType,
        country: addressData?.country,
        lat: addressData?.geodata_latitude,
        lng: addressData?.geodata_longitude,
        rehash: isRehash,
    }
    return addressDetails
}

export const parseAddressData = (data) => {
    const parsedData = {
        key: "test_location",
        addressObj: {
            pincode: data.address.pincode,
            city: data.address.city,
            state: data.address.state,
            street: data.address.line_1,
        },
    }

    if (!data.is_serviceable) {
        parsedData.errorObj = {
            header: data.serviceable_remark,
            text: data.serviceable_description,
        }
    }
    return parsedData
}

export const parseConfirmBookingError = (error) => {
    if (error?.error?.errors?.[0]?.message)
        return {
            errorLabel: error?.error?.errors?.[0]?.message?.error_label,
            errorMessage: error?.error?.errors?.[0]?.message?.error_message,
            redirectionUrl: error?.error?.errors?.[0]?.message?.redirection_url,
            gaDetails: error?.error?.ga_details,
        }
    return {
        message: error?.error?.message,
    }
}
